import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter } from 'rxjs';
import { ITableQueryData } from 'src/app/_metronic/shared/components/generic-table/generic-table.component';

@Injectable({
  providedIn: 'root'
})
export class TableStateService {
  private previousUrl: string = '';
  private currentUrl: string = '';
  private cachedState: { [key: string]: ITableQueryData } = {};
  private cachedTab: { [baseRoute: string]: string } = {};

  constructor(private router: Router) {
    this.currentUrl = this.router.url;
    this.router.events
      .pipe(filter((event): event is RoutesRecognized => event instanceof RoutesRecognized))
      .subscribe((event: RoutesRecognized) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects || event.url;
      });
  }

  public getPreviousUrl(): string {
    return this.previousUrl;
  }

  public getCurrentUrl(): string {
    return this.currentUrl;
  }

  public saveState(key: string, state: ITableQueryData): void {
    this.cachedState[key] = state;
  }

  public saveActiveTab(baseRoute: string, tab: string): void {
    this.cachedTab[baseRoute] = tab;
  }

  public getActiveTab(baseRoute: string): string | null {
    if (this.isReturnedFromChild(baseRoute)) {
      return this.cachedTab[baseRoute] || null;
    }
    delete this.cachedTab[baseRoute];
    return null;
  }

  public isReturnedFromChild(baseRoute: string): boolean {
    const cleanPrev = (this.previousUrl || '').split('?')[0];
    const normalizedBase = baseRoute.startsWith('/') ? baseRoute : '/' + baseRoute;
    const expectedChildPrefix = normalizedBase.endsWith('/') ? normalizedBase : normalizedBase + '/';
    return cleanPrev.startsWith(expectedChildPrefix);
  }

  /**
   * Mengembalikan cache state HANYA jika navigasi sebelumnya berasal dari child / sub-route (halaman detail/action).
   * Jika navigasi berasal dari menu lain, sidebar, atau reload, cache dihapus dan return null.
   *
   * @param baseRoute Base route dari list, misal '/sign-ba-inspection-dist' atau '/coi'
   * @param key Key cache (default sama dengan baseRoute)
   */
  public getSavedStateIfReturnedFromChild(baseRoute: string, key: string = baseRoute): ITableQueryData | null {
    if (this.isReturnedFromChild(baseRoute)) {
      return this.cachedState[key] || null;
    }

    // Jika datang dari menu lain atau sidebar, reset cache
    this.clearState(key);
    delete this.cachedTab[baseRoute];
    return null;
  }

  public clearState(key: string): void {
    delete this.cachedState[key];
  }

  public clearAllForBaseRoute(baseRoute: string): void {
    delete this.cachedTab[baseRoute];
    const prefix = baseRoute.startsWith('/') ? baseRoute : '/' + baseRoute;
    Object.keys(this.cachedState).forEach(k => {
      if (k.startsWith(prefix)) {
        delete this.cachedState[k];
      }
    });
  }
}
